<template>
  <NuxtLink
    v-bind="$attrs"
    :to="to"
    :target="target"
    :rel="computedRel"
    :class="{ active: isActive }"
  >
    <slot />
  </NuxtLink>
</template>

<script setup lang="ts">
  const props = defineProps<{
    to?: string
    target?: string
    rel?: string
  }>()

  const route = useRoute()

  const computedRel = computed(() => {
    if (props.target === '_blank' && !props.rel) {
      return 'noopener noreferrer'
    }
    return props.rel
  })

  const isActive = computed(() => {
    return route.path === props.to
  })
</script>
